__turbopack_context__.v({
  "active": "MaturityGroupItemTable-module-scss-module__OoTaBa__active",
  "gray": "MaturityGroupItemTable-module-scss-module__OoTaBa__gray",
  "green": "MaturityGroupItemTable-module-scss-module__OoTaBa__green",
  "lightGreen": "MaturityGroupItemTable-module-scss-module__OoTaBa__lightGreen",
  "lightRed": "MaturityGroupItemTable-module-scss-module__OoTaBa__lightRed",
  "red": "MaturityGroupItemTable-module-scss-module__OoTaBa__red",
  "yellow": "MaturityGroupItemTable-module-scss-module__OoTaBa__yellow",
});
